// extracted by mini-css-extract-plugin
export var cardHeader = "_i1-0";
export var reorderHandle = "_i1-3";
export var titleArea = "_i1-1";
export var titleAreaWithHandle = "_i1-2";